import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6498a20a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border" })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "row"
}
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-download" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "CSV", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "d-flex flex-column" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "d-flex flex-column" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "d-flex flex-column" }
const _hoisted_16 = { class: "d-flex flex-column" }
const _hoisted_17 = { class: "d-flex flex-column" }
const _hoisted_18 = { class: "d-flex flex-column" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GridToolbar = _resolveComponent("GridToolbar")!
  const _component_k_switch = _resolveComponent("k-switch")!
  const _component_Grid = _resolveComponent("Grid")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && _ctx.products?.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Grid, {
              "data-items": _ctx.products,
              columns: _ctx.columns
            }, {
              productName: _withCtx(({props}) => [
                _createElementVNode("td", {
                  onClick: ($event: any) => (_ctx.onRowClick($event, props.dataItem))
                }, [
                  _createElementVNode("span", null, _toDisplayString(props.dataItem.FileName), 1)
                ], 8, _hoisted_9)
              ]),
              description: _withCtx(({props}) => [
                _createElementVNode("td", {
                  onClick: ($event: any) => (_ctx.onRowClick($event, props.dataItem))
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.dataItem.Variants, (variant) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: variant.Id
                      }, [
                        _createElementVNode("span", null, _toDisplayString(variant.VariantDescription) + _toDisplayString(variant.CustomFinishingDetails ? `, ${variant.CustomFinishingDetails}` : ''), 1)
                      ]))
                    }), 128))
                  ])
                ], 8, _hoisted_10)
              ]),
              variants: _withCtx(({props}) => [
                _createElementVNode("td", {
                  onClick: ($event: any) => (_ctx.onRowClick($event, props.dataItem))
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.dataItem.Variants, (variant) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: variant.Id
                      }, [
                        _createElementVNode("span", null, _toDisplayString(variant.Variant), 1)
                      ]))
                    }), 128))
                  ])
                ], 8, _hoisted_12)
              ]),
              sku: _withCtx(({props}) => [
                _createElementVNode("td", {
                  onClick: ($event: any) => (_ctx.onRowClick($event, props.dataItem))
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.dataItem.Variants, (variant) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: variant.Id
                      }, [
                        _createElementVNode("span", null, _toDisplayString(variant.SKU), 1)
                      ]))
                    }), 128))
                  ])
                ], 8, _hoisted_14)
              ]),
              doNotPrint: _withCtx(({props}) => [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.dataItem.Variants, (variant) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: variant.Id
                      }, [
                        _createVNode(_component_k_switch, {
                          checked: variant.DoNotPrint,
                          onChange: ($event: any) => (_ctx.onDoNotPrintChange($event, variant))
                        }, null, 8, ["checked", "onChange"])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              forceOrderOnHold: _withCtx(({props}) => [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.dataItem.Variants, (variant) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: variant.Id
                      }, [
                        _createVNode(_component_k_switch, {
                          checked: variant.ManualEcommerceOrderAutoHoldEnabled,
                          onChange: ($event: any) => (_ctx.onForceOrderOnHoldChange($event, variant))
                        }, null, 8, ["checked", "onChange"])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              additionalPricing: _withCtx(({props}) => [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.dataItem.Variants, (variant) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: variant.Id
                      }, [
                        (variant.AdditionalPricing)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(variant.AdditionalPricing) + _toDisplayString(_ctx.currencySymbol), 1))
                          : _createCommentVNode("", true),
                        (!variant.AdditionalPricing)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, "-"))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_GridToolbar, null, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      class: "k-button k-primary",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadCsv && _ctx.downloadCsv(...args)))
                    }, _hoisted_8)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data-items", "columns"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}